import { ModelBase } from '../../core/model/model-base';

export class PrintOrder extends ModelBase {
  constructor() {
    super();
  }

  caption: string;
  ordered: Date;
  completed: Date;
  isCompleted: boolean;

  toString(culture?: string): string {
    return this.caption;
  }

  toJSON() {
    return this;
  }
}
